import {SALES_WINDOW_DAYS} from '../../../../shared/collection-sort.js';

export default function RankingRulesCard() {
  return <s-section heading="How products are ranked">
    <s-stack gap="base">
      <s-paragraph>Each rule only decides between products the rules above it rank equally.</s-paragraph>
      <s-ordered-list>
        <s-list-item><s-text type="strong">In stock</s-text> before out of stock. A product is out of stock only when no variant can be sold.</s-list-item>
        <s-list-item><s-text type="strong">New</s-text> products, tagged <code>new_product</code>.</s-list-item>
        <s-list-item><s-text type="strong">EVP brands</s-text> before third-party brands.</s-list-item>
        <s-list-item><s-text type="strong">Most units sold</s-text> in the last {SALES_WINDOW_DAYS} days.</s-list-item>
        <s-list-item><s-text type="strong">Newest</s-text> published first.</s-list-item>
      </s-ordered-list>
      <s-paragraph>Remaining ties, and every product when sales data is unavailable, follow Shopify's best-selling order.</s-paragraph>    </s-stack>
  </s-section>;
}
